!((document, Drupal, $) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.systemStatus = {
    attach: function(context, settings) {
      var self = this;
      var systemStatusMobileMenus = $('.system-status');
      let assetClassIds = [];
      var AUTO_REFRESH_IN_MS = drupalSettings.system_status.ss_auto_refresh * 1000;
      for (var i = 0; i < systemStatusMobileMenus.length; i++) {
        let assetClassItem = systemStatusMobileMenus[i];
        if (!assetClassIds.includes(assetClassItem.getAttribute('asset-class')) &&
        assetClassItem.getAttribute('asset-class') != null) {
          assetClassIds.push(assetClassItem.getAttribute('asset-class'));
        }
      }

      var systemStatus = new self.SystemStatusUpdate(
          systemStatusMobileMenus,
          assetClassIds,
          AUTO_REFRESH_IN_MS
        );
      systemStatus.initialize();
    },
    SystemStatusUpdate: function(systemStatusMobileMenus, assetClassIds, refreshTime) {
      var self = this;
      self.systemStatusMobileMenus = systemStatusMobileMenus;
      self.assetClassIds = assetClassIds;
      self.dataReceived = undefined;
      self.refreshTime = refreshTime;

      self.initialize = function() {
        self.getData();
        if (self.refreshTime != 0 && self.refreshTime != '') {
          self.autoRefresh();
        }
      };

      // Ajax call to get the system status.
      self.getData = function() {
        var url = self.buildUrl();
        try {
          $.getJSON(url, function(data) {
            if (data.status === 'fail' || data.status === 'error') {
              // Do nothing.
            } else {
              self.dataReceived = data;
              self.updateStatus();
            }
          });
        } catch (err) {
          console.log('Error: ', err);
        }
      }

      self.buildUrl = function() {
        // Set URL.
        var url = '/system-status/list?_format=json&ID=';
        for (var i = 0; i < assetClassIds.length; i++) {
          url += assetClassIds[i];

          if (i < assetClassIds.length - 1) {
            url += ',';
          }
        }
        return url;
      }

      self.updateStatus = function() {
        let dataObj = self.dataReceived['system status'];
        var statusCode, icon, systemStatus = [];
        for (var j = 0; j < self.systemStatusMobileMenus.length; j++) {
          for (var k = 0; k < dataObj.length; k++) {
            systemStatus[k] = dataObj[k]['system_status'];
            if (self.systemStatusMobileMenus[j].getAttribute('asset-class') === dataObj[k]['ID']) {
              if (dataObj[k]['system_status'] == 1) {
                statusCode = 'green';
              }
              else if (dataObj[k]['system_status'] == 2) {
                statusCode = 'yellow';
              }
              else if (dataObj[k]['system_status'] == 3) {
                statusCode = 'red';
              }
              icon = '<icon class="fas fa-circle ' + statusCode + '"></icon>';
              if ($(self.systemStatusMobileMenus[j]).find('a:first icon, p.system-status-comp-label icon').length) {
                $(self.systemStatusMobileMenus[j]).find('a:first icon, p.system-status-comp-label icon').remove();
              }
              $(self.systemStatusMobileMenus[j]).find('a:first, p.system-status-comp-label').prepend(icon);
              break;
            }
          }
        }
      }

      // Auto refresh for System Status.
      self.autoRefresh = function() {
        let refreshTime = self.refreshTime;
        window.setInterval(function() {
          self.getData();
        }, refreshTime);
      }
    }
  };
})(document, Drupal, jQuery);
jQuery('#block-system-status .miax-system-status').hover(function() {
  jQuery('#block-system-status .nav-item.system-status .dropdown-system-status').toggleClass('show'); 
});

